import axiosInstance from './axios-instance';

export const fetchLocations = (locationIds: string[]) =>
  axiosInstance.get('/location/locations', { params: { locationIds }});

export const fetchLocationWidget = (widgetId: string) => axiosInstance.get(`/location/widgets/${widgetId}`);
